import { render, staticRenderFns } from "./CampoIndicadorEstadoComercial.vue?vue&type=template&id=b8ca9022&scoped=true&"
import script from "./CampoIndicadorEstadoComercial.vue?vue&type=script&lang=js&"
export * from "./CampoIndicadorEstadoComercial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8ca9022",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b8ca9022')) {
      api.createRecord('b8ca9022', component.options)
    } else {
      api.reload('b8ca9022', component.options)
    }
    module.hot.accept("./CampoIndicadorEstadoComercial.vue?vue&type=template&id=b8ca9022&scoped=true&", function () {
      api.rerender('b8ca9022', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/dte/componentes/campos/CampoIndicadorEstadoComercial.vue"
export default component.exports